<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Purchase Credit Notes"></list-nav-header>


            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items">
                        <div class="icon">

                        </div>
                        <div class="info">
                            <span>{{ item.supplier }}</span>
                            <span>{{ item.raised }}</span>
                            <span>{{ item.reference }}</span>
                            <span>{{ item.costs.gross }}</span>
                        </div>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Credit Notes
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Status</th>
                        <th scope="col" v-if="view_all">Invoice Date</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Package</th>
                        <th scope="col" v-if="view_all">Supplier</th>
                        <th scope="col" v-if="view_all">Supplier Reference</th>
                        <th scope="col">Amount</th>
                        <th scope="col" v-if="view_all">Approval</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference"><a :href="item._links.frontend.view">{{ item.reference }}</a></td>
                        <td data-label="Status">{{ item.status }}</td>
                        <td data-label="Invoice Date" v-if="view_all">{{ item.raised }}</td>
                        <td data-label="Due Date">{{ item.delivery_date }}</td>
                        <td data-label="Package" v-if="item.package"><a :href="item.package.data._links.frontend.view">{{ item.package.data.name }}</a></td>
                        <td data-label="Package" v-else>No Package</td>
                        <td data-label="Supplier" v-if="view_all">{{ item.supplier }}</td>
                        <td data-label="Supplier Reference" v-if="view_all">{{ item.supplier_reference }}</td>
                        <td data-label="Amount">&pound;{{ item.costs.gross }}</td>
                        <td data-label="Approval" v-if="view_all">{{ item.approved_by.name }} on {{ item.approved_at }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Credit Notes
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>


                <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                    <span slot="no-more">
                      End Of Purchase Credit Notes
                    </span>
                </infinite-loading>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props:['compact','packageId'],
        data() {
            return {
                name: 'pcns',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            view_all(){
                if(this.compact === true || this.compact == 'true')
                {
                    return false;
                }

                return true;
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.pcns.index;
                var params = {};

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
